import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, debounceTime, map, of, switchMap } from 'rxjs';

import { SharedService } from '@offconon/core-api';

import * as LayoutActions from './layout.actions';

@Injectable()
export class LayoutEffects {
  private actions$ = inject(Actions);
  private sharedService = inject(SharedService);

  getIndicators$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LayoutActions.getIndicators),
      debounceTime(1000),
      switchMap(() => {
        return this.sharedService.sharedIndicatorsRetrieve().pipe(
          map((counts: any) => {
            return LayoutActions.getIndicatorsSuccess({ counts });
          }),
          catchError((error) => {
            return of(LayoutActions.getIndicatorsFailure({ error }));
          }),
        );
      }),
    ),
  );
}
